import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { List } from '@digsup/components-list';
import { StepsItem } from './StepsItem';
import { StepsContext } from './StepsContext';

const cx = classNames;

const Steps = ({
  items,
  spacing,
  variant,
  icon,
  children,
  className,
  ...props
}) => {
  const classes = cx('c-steps', className);

  return (
    <StepsContext.Provider value={{ variant, icon }}>
      <List spacing={spacing} className={classes} {...props}>
        {items && items.map((item, i) => <StepsItem {...item} key={i} />)}
        {children}
      </List>
    </StepsContext.Provider>
  );
};

Steps.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      status: PropTypes.oneOf(['done', 'current', 'wait']),
    }),
  ),
  spacing: PropTypes.oneOf(['small', 'medium', 'large', 'xlarge']),
  variant: PropTypes.oneOf(['flat', 'outlined']),
  icon: PropTypes.oneOf(['checkmark', 'bell-outline']),
  children: PropTypes.any,
  className: PropTypes.string,
};

Steps.defaultProps = {
  items: [],
  spacing: 'xlarge',
  variant: 'flat',
  icon: 'checkmark',
  className: '',
};

Steps.Item = StepsItem;

export { Steps };
